<template>
	<div>
		<el-select
			v-model="uid"
			filterable
			remote
			clearable
			ref="select"
			:style="styleData"
			:multiple="multiple"
			:placeholder="placeholder"
			:remote-method="remoteMethod"
			:loading="loading"
			:size="size"
		>
			<el-option v-if="isMyShow" label="我自己受理" :value="info.uid" />
			<el-option
				v-for="item in userList"
				:key="item.id"
				:label="`${item.true_name} - ${item.org_name}`"
				:value="item.id"
			/>
		</el-select>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getUser, getUserIds } from '@/api/sysuser'

export default {
	name: 'SelectUser',
	model: {
		prop: 'value',
		event: 'change'
	},
	props: {
		value: [Number, String, Array],
		multiple: {
			type: Boolean,
			default: false
		},
		size: {
			type: String,
			default: ''
		},
		styleData: {
			type: String,
			default: 'width: 200px;'
		},
		isMyShow: {
			type: Boolean,
			default: false
		},
		placeholder: {
			type: String,
			default: '请选择创建人'
		}
	},
	data() {
		return {
			loading: false,
			uid: null,
			userList: [],
			limit: 20,
			org_code: 1,
			selectedLabel: ''
		}
	},
	computed: {
		...mapGetters(['info'])
	},
	watch: {
		value: {
			handler(val) {
				this.uid = val
				if (val) {
					this.findUserById()
				}
			},
			immediate: true //立即监听
		},
		uid(val) {
			this.$emit('change', val)
			this.$nextTick(() => {
				this.selectedLabel = this.$refs.select.selectedLabel
			})
		}
	},
	methods: {
		remoteMethod(query) {
			if (query !== '') {
				this.loading = true
				getUser({ page: 1, limit: this.limit, org_code: this.org_code, true_name: query, headquarter: 1 })
					.then(res => {
						this.loading = false
						this.userList = res.data.list
					})
					.catch(_ => {
						this.loading = false
						this.userList = []
					})
			} else {
				this.userList = []
			}
		},
		resetClearUserList() {
			this.userList = []
		},
		// 根据uid获取姓名
		async findUserById() {
			let query = {
				limit: this.limit
			}
			if (this.multiple) {
				query.limit = this.uid?.length ?? 0
				query.ids = this.uid?.join(',')
			} else {
        /**
         * 修复ARMS监控问题
         * @author 王文龙
         * @date 2024-02-28
         * @description Cannot read properties of null (reading 'find')
         * @link https://arms.console.aliyun.com/retcode#/error-diagnose?expr=t%3Derror%20and%20Cannot%2520read%2520properties%2520of%2520null%2520%2528reading%2520%2527find%2527%2529&msg=Cannot%2520read%2520properties%2520of%2520null%2520%2528reading%2520%2527find%2527%2529&begin=1709176874000&end=1709263274000
         */
        const obj = this.userList?.find(item => item.id === this.uid)
				if (obj) {
					return
				}
				query.id = this.uid
			}
			try {
				const { data = {} } = await getUser({ page: 1, ...query })
				const { list = [] } = data
				this.userList = list || []
			} catch (error) {
				console.error(error)
			}
		}
	}
}
</script>
